export default "__VITE_ASSET__Bn4nQ9zP__"